import axios from "axios";
import { toast } from 'react-toastify';
import { clearStatusMetadataSessionCache } from "libs/context/statusMetadataSessionCache";
import { getSsoApiBaseUrl } from "helpers/ssoApiBase";
const createAxiosInstance = (baseURL = process.env.REACT_APP_API_URL) => {
    const headers = {
        "Content-Type": "application/json; charset=utf-8",
        "Accept": "application/json; charset=utf-8",
    };

    return axios.create({
        baseURL,
        timeout: 900000,
        headers: headers,
        // withCredentials: true,
        auth: {
            username: "FUNNTPYKLWJN",
            password: "d7#Vt9X$kLp!r5Wc?yZ3uB*m",
        },
    });
};

const createAxiosInstanceMultipart = () => {
    const headers = {
        "Content-Type": "multipart/form-data; charset=utf-8",
        "Accept": "multipart/form-data; charset=utf-8",
    };

    return axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        timeout: 900000, // 30 sec
        headers: headers,
        // withCredentials: true,
        auth: {
            username: "FUNNTPYKLWJN",
            password: "d7#Vt9X$kLp!r5Wc?yZ3uB*m",
        },
    });
};

// Usage:
const instance = createAxiosInstance();
const instanceV2 = createAxiosInstance(process.env.REACT_APP_API_URL_V2);
const instanceSso = createAxiosInstance(`${getSsoApiBaseUrl()}/`);
const instanceMultipart = createAxiosInstanceMultipart();
// CancelToken source for cancelling requests
axios.CancelToken.source();
// Function to make a GET request
const logout = () => {
    localStorage.removeItem("authUser");
    localStorage.removeItem("authUser");
    localStorage.removeItem("temp");
    clearStatusMetadataSessionCache();
    window.location.href = "/login"; // Redirect to login page
};
const getWithInstance = async (axiosInstance, url) => {
    let authUser = JSON.parse(localStorage.getItem("authUser")) || null;
    
    try {
        const response = await axiosInstance.get(url,authUser? {
            headers: { 
                "Content-Type" : "multipart/form-data",
                "X-Access-Token": `${authUser}`
            }
        }: {
            headers: { 
                "Content-Type" : "multipart/form-data",
            }
        });
        if (response.data.status === 'error' && (response.data.invalid_token === 1 || response.data.login_required === 1)) {
            if(response.data.message) {
                toast.error(response.data.message);
            }
            logout();
        }
        return response.data;
    } catch (error) {
        if(error?.status==401 || error?.status=="401"){
            toast.error(error?.response?.data?.message || "An Authentication error occurred");
            logout()
        }
        else{
        toast.error(error?.response?.data?.error?.message || "An error occurred");
        }

    }
};

const GET = async (url) => getWithInstance(instance, url);

/** GET against `REACT_APP_API_URL_V2` (e.g. common/plan). */
const GET_V2 = async (url) => getWithInstance(instanceV2, url);
  
const postWithInstance = async (axiosInstance, url, data) => {
    let authUser = JSON.parse(localStorage.getItem("authUser")) || null;

    try {
        const response = await axiosInstance.post(url, data, authUser? {
            headers: { 
                // "Content-Type" : "multipart/form-data",
                'Content-Type': 'application/json; charset=utf-8',
                "X-Access-Token": `${authUser}`
            }
        }: {
            headers: { 
                // "Content-Type" : "multipart/form-data",
                'Content-Type': 'application/json; charset=utf-8',
            }
        });
        if (response.data.status === 'error' && (response.data.invalid_token === 1 || response.data.login_required === 1)) {
            if(response.data.message) {
                toast.error(response.data.message);
            }
            // logout();
        }
        return response.data;
    } catch (error) {
        if(error?.status==401 || error?.status=="401"){
            toast.error(error?.response?.data?.message || "An Authentication error occurred");
            // logout()
        }
        else{
        toast.error(error?.response?.data?.error?.message || "An error occurred");
        }

        // throw error;
    }
};

  // Function to make a POST request
const POST = async (url, data) => postWithInstance(instance, url, data);

/** POST against `REACT_APP_API_URL_V2` (e.g. async client dropdown). */
const POST_V2 = async (url, data) => postWithInstance(instanceV2, url, data);

/** GET/POST against SSO API v1 base (`auth/sso/*`). */
const GET_SSO = async (url) => getWithInstance(instanceSso, url);
const POST_SSO = async (url, data) => postWithInstance(instanceSso, url, data);

/** Multipart errors: return JSON body when present so callers can handle codes (e.g. CONFIRM_REQUIRED). */
const handleMultipartAxiosError = (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data;
    if (status === 401 || status === "401") {
        toast.error("An Authentication error occurred");
        logout();
        return undefined;
    }
    if (data?.error?.code === "CONFIRM_REQUIRED") {
        return data;
    }
    const msg =
        data?.error?.message || data?.message;
    if (msg) {
        toast.error(msg);
    }
    return data;
};

const MULTIPART_POST = async (url, data) => {
    // let authUser = localStorage.getItem("authUser") ? localStorage.getItem("authUser") : null;
    let authUser = JSON.parse(localStorage.getItem("authUser")) || null;

    try {
        const response = await instanceMultipart.post(url, data, authUser? {
            headers: { 
                "Content-Type" : "multipart/form-data",
                // 'Content-Type': 'application/json; charset=utf-8',
                "X-Access-Token": `${authUser}`
            }
        }: {
            headers: { 
                "Content-Type" : "multipart/form-data",
                // 'Content-Type': 'application/json; charset=utf-8',
            }
        });
        if (response.data.status === 'error' && (response.data.invalid_token === 1 || response.data.login_required === 1)) {
            if(response.data.message) {
                toast.error(response.data.message);
            }
            logout();
        }
        return response.data;
    } catch (error) {
        return handleMultipartAxiosError(error);
    }
};

const MULTIPART_PUT = async (url, data) => {
    // let authUser = localStorage.getItem("authUser") ? localStorage.getItem("authUser") : null;
    let authUser = JSON.parse(localStorage.getItem("authUser")) || null;

    try {
        const response = await instance.put(url, data, authUser? {
            headers: { 
                "Content-Type" : "multipart/form-data",
                // 'Content-Type': 'application/json; charset=utf-8',
                "X-Access-Token": `${authUser}`
            }
        }: {
            headers: { 
                "Content-Type" : "multipart/form-data",
                // 'Content-Type': 'application/json; charset=utf-8',
            }
        });
        if (response.data.status === 'error' && (response.data.invalid_token === 1 || response.data.login_required === 1)) {
            if(response.data.message) {
                toast.error(response.data.message);
            }
            logout();
        }
        return response.data;
    } catch (error) {
        return handleMultipartAxiosError(error);
    }
};

// const PUT = async (url, data) => {
//     try {
//         const response = await instance.put(url, data, {});
//         //if (response.data.status) {}
//         return response.data;
//     } catch (error) {
//         throw error;
//     }
// };

const PUT = async (url, data) => {
    // let authUser = localStorage.getItem("authUser") ? localStorage.getItem("authUser") : null;
    let authUser = JSON.parse(localStorage.getItem("authUser")) || null;

    try {
        const response = await instance.put(url, data, authUser? {
            headers: { 
                // "Content-Type" : "multipart/form-data",
                'Content-Type': 'application/json; charset=utf-8',
                "X-Access-Token": `${authUser}`
            }
        }: {
            headers: { 
                // "Content-Type" : "multipart/form-data",
                'Content-Type': 'application/json; charset=utf-8',
            }
        });
        if (response.data.status === 'error' && (response.data.invalid_token === 1 || response.data.login_required === 1)) {
            if(response.data.message) {
                toast.error(response.data.message);
            }
            logout();
        }
        return response.data;
    } catch (error) {
        const data = error?.response?.data;
        if (data?.error?.code === "CONFIRM_REQUIRED") {
            return data;
        }
        if(error?.status==401 || error?.status=="401"){
            toast.error(error?.response?.data?.message || "An Authentication error occurred");
            logout()
        }
        else{
        toast.error(error?.response?.data?.error?.message || "An error occurred");
        }

        // throw error;
    }
};
  
// Function to make a DELETE request
const DEL = async (url, data) => {
    let authUser = JSON.parse(localStorage.getItem("authUser")) || null;
    
    try {
        const response = await instance.delete(url, authUser? {
            data,
            headers: { 
                "Content-Type" : "application/json; charset=utf-8",
                "X-Access-Token": `${authUser}`
            }
        }: {
            data,
            headers: { 
                "Content-Type" : "application/json; charset=utf-8",
            }
        });
        if (response.data.status === 'error' && (response.data.invalid_token === 1 || response.data.login_required === 1)) {
            if(response.data.message) {
                toast.error(response.data.message);
            }
            logout();
        }
        return response.data;
    } catch (error) {
        if(error?.status==401 || error?.status=="401"){
            toast.error(error?.response?.data?.message || "An Authentication error occurred");
            logout()
        }
        else{
        toast.error(error?.response?.data?.error?.message || "An error occurred");
        }

    }
};

const POST_BLOB = async (url, data) => {
    const authUser = JSON.parse(localStorage.getItem("authUser")) || null;

    try {
        const response = await instance.post(url, data, {
            responseType: "blob",
            headers: authUser
                ? {
                      "Content-Type": "application/json; charset=utf-8",
                      "X-Access-Token": `${authUser}`,
                  }
                : {
                      "Content-Type": "application/json; charset=utf-8",
                  },
        });

        return response;
    } catch (error) {
        if (error?.status === 401 || error?.status === "401") {
            toast.error(error?.response?.data?.message || "An Authentication error occurred");
            logout();
            return null;
        }

        toast.error(error?.response?.data?.error?.message || "An error occurred");
        return null;
    }
};

// Add more functions for other HTTP methods as needed

export { GET, GET_V2, POST, POST_V2, GET_SSO, POST_SSO, PUT, DEL, MULTIPART_POST, MULTIPART_PUT, POST_BLOB };